export enum leaveRequestStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    RM_APPROVED = 'RM_APPROVED',
    CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
    CANCELLATION_REJECTED = 'CANCELLATION_REJECTED',
    CANCELLED = 'CANCELLED'
}

export enum userRoles {
    HR_Manager = 'HR Manager',
    SUPER_USER = 'Super User',
    ASSISTANT_HR_MANAGER = 'Assistant HR Manager',
    HR_EXECUTIVE = 'HR Executive',
    REPORTING_MANAGER = 'Reporting Manager',
    GENERAL_USER = 'General User'
}